module.exports = __webpack_public_path__ + "images/wensink_small767ed7096a2da8aa248854fc94580bf9.png";